var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselCompass = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "nttjgmqmja"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#nttjgmqmja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(9 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#101C23",
    fillRule: "nonzero",
    d: "m15.127 30.255.786.99 3.403-2.145-.69-1.038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.315 4.194-5.848-3.046a11.464 11.464 0 0 0-2.399-.054c-.423.036-2.343.218-4.608 1.391-2.716 1.406-4.195 3.336-5.861 5.51-.943 1.233-2.185 2.877-3.186 5.35A19.573 19.573 0 0 0 .05 19.067c-.035.42-.165 2.188.227 4.225.197 1.026.482 1.886 1.081 2.73.221.31.435.549.59.709l7.407 3.735 13.96-26.273z",
    fill: "#2A2F68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4E568A",
    fillRule: "nonzero",
    transform: "rotate(-59.69 16.408 17.447)",
    cx: 16.408,
    cy: 17.447,
    rx: 14.982,
    ry: 8.942
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05 28.86a5.209 5.209 0 0 1-.696-.767 5.551 5.551 0 0 1-.729-1.376c-.56-1.507-.56-3.26-.556-3.957.01-1.484.214-2.624.324-3.164.21-1.026.518-1.864.866-2.843.155-.434.342-.964.596-1.556.132-.308.747-1.719 1.895-3.38 1.384-2 2.76-3.248 3.627-4.021.818-.731 1.307-1.069 1.699-1.31a10.457 10.457 0 0 1 3.995-1.434c.473-.068.891-.098 1.235-.109a6.538 6.538 0 0 1 .779.682s.339.357.612.825c.46.79.61 1.902.634 2.094.143 1.113.27 2.108.142 3.585-.134 1.525-.46 2.636-.75 3.6a23.713 23.713 0 0 1-2.373 5.384c-.512.85-1.291 2.127-2.64 3.554-.729.773-1.834 1.926-3.618 2.945-1.528.875-2.394 1.142-2.834 1.23a7.394 7.394 0 0 1-2.084.116",
    fill: "#8E94B4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.882 35.05a6.781 6.781 0 0 1 .821-1.969 7.337 7.337 0 0 1 1.07-1.33c.694-.687 1.367-1.1 1.943-1.426 1.676-.946 3.066-1.73 5.104-2.326 3.678-1.073 6.765-.742 8.778-.506 3.31.388 5.664 1.308 6.992 1.922 1.108.512 2.715 1.37 3.879 2.78.326.397.976 1.2 1.327 2.427.123.43.178.8.204 1.062v6.725a8.882 8.882 0 0 1-.408.91c-.216.416-1.197 2.225-3.777 3.893-2.591 1.677-5.173 2.163-6.941 2.478-1.602.285-4.964.719-9.033-.102-2.936-.592-4.767-1.538-5.461-1.92-2.205-1.218-3.107-2.358-3.42-2.782a8.512 8.512 0 0 1-1.174-2.224s.183-7.699.096-7.612z",
    fill: "#2A2F68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.567 36.637c0 4.385-6.483 7.735-14.481 7.483-7.998-.253-14.481-4.014-14.481-8.4s6.483-7.736 14.48-7.483c7.999.253 14.482 4.014 14.482 8.4z",
    fill: "#4E568A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.575 37.075a5.76 5.76 0 0 1-.354 1.085 5.98 5.98 0 0 1-.907 1.435c-1.124 1.338-2.78 2.238-3.444 2.592a16.44 16.44 0 0 1-3.189 1.303c-1.095.315-2.061.432-3.184.58-.499.068-1.11.148-1.813.193-.367.025-2.056.12-4.259-.21-2.66-.401-4.573-1.19-5.765-1.69-1.126-.473-1.698-.807-2.127-1.091a11.409 11.409 0 0 1-2.35-2.075 12.442 12.442 0 0 1-1.68-2.538c.026-.14.065-.324.123-.535.023-.086.094-.347.19-.606 0 0 .195-.527.531-1.04.565-.86 1.59-1.565 1.768-1.684 1.023-.693 1.936-1.311 3.434-1.907 1.54-.611 2.765-.827 3.83-1.01a24.575 24.575 0 0 1 6.27-.259c1.05.095 2.632.247 4.635.884 1.084.346 2.71.878 4.557 2.147 1.587 1.09 2.276 1.82 2.583 2.216.595.765.96 1.504 1.18 2.033",
    fill: "#F3F5F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "nonzero",
    d: "m28.321 38.263.028-2.837.17 2.894h-.193M28.522 38.385l-.03 2.838-.17-2.893h.193"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "nonzero",
    d: "m28.318 38.264-4.959-.027 5.056-.17v.19M28.532 38.065l5.407.028-5.514.168v-.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6394E",
    fillRule: "nonzero",
    d: "m28.356 38.57 5.76 2.984-5.125-3.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D8DAF",
    fillRule: "nonzero",
    d: "m28.456 37.74-5.76-2.987 5.125 3.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m27.719 38.204-4.888 3.073 5.44-2.61.85-.505 4.762-3.116-5.74 2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.476 43.617c5.315 0 9.623-2.373 9.623-5.3 0-2.928-4.308-5.301-9.623-5.301-5.315 0-9.623 2.373-9.623 5.3 0 2.928 4.308 5.301 9.623 5.301z",
    stroke: "#686969",
    strokeWidth: 0.122,
    strokeDasharray: 1.132
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#686969",
    strokeWidth: 0.122
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.053 39.907a4.88 4.88 0 0 1-.18-.543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.727 38.207c.024-4.025 5.556-7.284 12.375-7.284 6.82 0 12.376 3.274 12.376 7.31 0 .323-.036.643-.106.954",
    strokeDasharray: 1.169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.213 39.75a5.058 5.058 0 0 1-.224.527"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselCompass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-compass.91cb6cfb05170904776bcbf321856749.svg";